module.exports = __webpack_public_path__ + "static/media/Misc.0a7e5ec3.svg";